import { render, staticRenderFns } from "./MyGoodsModule.vue?vue&type=template&id=13066b69&scoped=true&"
import script from "./MyGoodsModule.vue?vue&type=script&lang=ts&"
export * from "./MyGoodsModule.vue?vue&type=script&lang=ts&"
import style0 from "./MyGoodsModule.vue?vue&type=style&index=0&id=13066b69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13066b69",
  null
  
)

export default component.exports